/**
 * Pieces shared by the public cert page (CertSalesPage) and "Find your
 * path" (CertPathPage): the call booking modal and "What's holding you
 * back?". A call is always one tap away, as the backup to enrolling.
 */
import React, { useEffect, useState } from "react";
import { Check, Phone, X, ArrowRight } from "lucide-react";
import { GOLD } from "../constants/theme";
import { OBJECTIONS } from "../certification/certPath";
import { logEvent } from "../utils/analytics";

// Same GHL calendar the in-app info-call page uses.
export const CALL_WIDGET = "https://go.byanymeanscoaches.com/widget/bookings/bam-coaches-certification";

const CARD = "#121212";
const LINE = "rgba(255,255,255,0.08)";
const TEXT = "#F5F0E8";
const MID = "#B8B2A4";

export function CallModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div role="dialog" aria-modal="true" aria-label="Book a call" onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 50, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: 720, height: "min(86vh, 760px)", background: "#fff", borderRadius: 14, overflow: "hidden", position: "relative" }}>
        <button onClick={onClose} aria-label="Close" style={{ position: "absolute", top: 8, right: 8, zIndex: 2, background: "#111", color: "#fff", border: "none", borderRadius: 18, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}><X size={18} /></button>
        <iframe title="Book a call with BAM" src={CALL_WIDGET} style={{ width: "100%", height: "100%", border: "none" }} />
      </div>
    </div>
  );
}

/**
 * "What's holding you back?" Tap the worry, get the straight answer, then
 * Enroll or book a call. Which worry they tap is logged, so we learn what
 * actually stops people.
 */
export function ObjectionPicker({ onEnroll, onCall, enrollLabel, from }) {
  const [picked, setPicked] = useState(null);
  const o = OBJECTIONS.find((x) => x.id === picked);
  return (
    <div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {OBJECTIONS.map((x) => {
          const on = x.id === picked;
          return (
            <button key={x.id} onClick={() => {
              setPicked(on ? null : x.id);
              if (!on) logEvent("cert_objection_pick", { objection: x.id, from });
              if (!on && x.call) onCall(`objection_${from}`);
            }} style={{
              padding: "10px 14px", borderRadius: 999, cursor: "pointer", fontSize: 14, fontWeight: 600,
              background: on ? `${GOLD}22` : "transparent", color: on ? GOLD : TEXT, border: `1px solid ${on ? GOLD : LINE}`,
            }}>{x.label}</button>
          );
        })}
      </div>
      {o && !o.call && (
        <div style={{ marginTop: 14, background: CARD, border: `1px solid ${LINE}`, borderRadius: 12, padding: 20 }}>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 10 }}>
            {o.points.map((pt) => (
              <li key={pt} style={{ display: "flex", gap: 10, color: MID, fontSize: 15, lineHeight: 1.55 }}>
                <Check size={17} color={GOLD} style={{ flexShrink: 0, marginTop: 3 }} />{pt}
              </li>
            ))}
          </ul>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 16 }}>
            <button onClick={() => onEnroll(`objection_${o.id}`)} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: GOLD, color: "#111", border: "none", borderRadius: 10, padding: "12px 18px", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>
              {enrollLabel} <ArrowRight size={15} strokeWidth={2.5} />
            </button>
            <button onClick={() => onCall(`objection_${o.id}`)} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "transparent", color: TEXT, border: `1px solid ${LINE}`, borderRadius: 10, padding: "12px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
              <Phone size={15} /> Book a call
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
